let promise = null;

export function loadGoogleMaps() {
  const key = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

  // STEP 1 confirm the key is being read
  console.log('[GoogleMaps] API key present:', !!key, '| value starts with:', key ? key.slice(0, 8) : 'N/A');

  if (!key || key === 'your_key_here') {
  return Promise.reject(new Error('Google Maps API key not configured.'));
  }

  // Already loaded
  if (window.google?.maps?.places) {
  console.log('[GoogleMaps] Already loaded skipping script injection');
  return Promise.resolve();
  }

  // In-flight
  if (promise) {
  console.log('[GoogleMaps] Load already in progress reusing promise');
  return promise;
  }

  // Use the `callback` parameter so Google Maps signals readiness itself
  // (more reliable than onload, which can fire before window.google.maps.places is ready)
  promise = new Promise((resolve, reject) => {
  window.__googleMapsReady = () => {
  console.log('[GoogleMaps] Callback fired window.google.maps.places available:', !!window.google?.maps?.places);
  delete window.__googleMapsReady;
  resolve();
  };

  const script = document.createElement('script');
  script.src = `https://maps.googleapis.com/maps/api/js?key=${key}&libraries=places&callback=__googleMapsReady`;
  script.async = true;

  script.onerror = (e) => {
  console.error('[GoogleMaps] Script load failed check API key restrictions and billing:', e);
  promise = null;
  delete window.__googleMapsReady;
  reject(new Error('Failed to load Google Maps script.'));
  };

  document.head.appendChild(script);
  console.log('[GoogleMaps] Script injected:', script.src);
  });

  return promise;
}
